import { createSelector } from 'reselect'
import { getFreeTrialStartedAtUserSelect } from 'modules/training/modules/training-users/selectors/get-free-trial-started-at/index.js'
import { getFreeTrialEndedAtUserSelect } from 'modules/training/modules/training-users/selectors/get-free-trial-ended-at/index.js'

export const hasFreeTrialStartedButNotEndedUserSelect = createSelector(
  getFreeTrialStartedAtUserSelect,
  getFreeTrialEndedAtUserSelect,
  (freeTrialStartedAt, freeTrialEndedAt) => (
    !!freeTrialStartedAt && !freeTrialEndedAt
  )
)
